// Single source of truth for who can reach the Kaiya admin area.
// Access levels live in the global config (`@/config`); this module holds the
// helpers that consume them.

import {
  ADMIN_TYPE_PROSCI,
  KAIYA_SECTION_LEVELS,
  KAIYA_SUPER_LEVEL,
} from '@/config';

interface AdminLike {
  type?: string;
  level?: string;
}

export function canAccessKaiyaSection(user?: AdminLike | null): boolean {
  return (
    user?.type === ADMIN_TYPE_PROSCI &&
    KAIYA_SECTION_LEVELS.includes(user?.level as (typeof KAIYA_SECTION_LEVELS)[number])
  );
}

export function canAccessKaiyaSuper(user?: AdminLike | null): boolean {
  return user?.type === ADMIN_TYPE_PROSCI && user?.level === KAIYA_SUPER_LEVEL;
}
